import React from 'react';
import { buildTeamTheme } from '../../lib/colors';

interface TeamThemeProviderProps {
  primary?:   string;
  secondary?: string;
  children:   React.ReactNode;
  teamId?:    string;
}

/**
 * Sets CSS custom properties for --team-primary, --team-primary-on,
 * --team-primary-tint, --team-secondary, --team-secondary-on on the
 * wrapping div. All descendant components read these via var().
 *
 * Usage:
 *   <TeamThemeProvider primary={team.primary_color} secondary={team.secondary_color}>
 *     <TeamHero ... />
 *   </TeamThemeProvider>
 */
export const TeamThemeProvider: React.FC<TeamThemeProviderProps> = ({
  primary   = '#0F2748',
  secondary = '#FFC72C',
  teamId,
  children,
}) => {
  const theme = buildTeamTheme(primary, secondary);

  const style = {
    '--team-primary':      theme.primary,
    '--team-primary-on':   theme.primaryOn,
    '--team-primary-tint': theme.primaryTint,
    '--team-secondary':    theme.secondary,
    '--team-secondary-on': theme.secondaryOn,
  } as React.CSSProperties;

  return (
    <div style={style} data-team-id={teamId}>
      {children}
    </div>
  );
};

export default TeamThemeProvider;
